module.exports = __webpack_public_path__ + "static/media/logo.4edccb2f.svg";